import type { Theme, ThemeChoice } from './types.js';

export const THEME_KEY = 'sm_theme';

export interface ThemeEnvironment {
  stored?: string | null;
  prefersDark?: boolean;
}

export function isThemeChoice(value: unknown): value is ThemeChoice {
  return value === 'light' || value === 'dark' || value === 'system';
}

/** The phone's own setting decides unless someone chose otherwise (PRD 9.3). */
export function resolveTheme({ stored, prefersDark }: ThemeEnvironment): Theme {
  if (stored === 'light' || stored === 'dark') return stored;
  return prefersDark ? 'dark' : 'light';
}

export function nextChoice(current: ThemeChoice, resolved: Theme): ThemeChoice {
  if (current === 'system') return resolved === 'dark' ? 'light' : 'dark';
  return current === 'dark' ? 'light' : 'dark';
}

export function readChoice(storage?: Pick<Storage, 'getItem'>): ThemeChoice {
  try {
    const value = storage?.getItem(THEME_KEY);
    return isThemeChoice(value) ? value : 'system';
  } catch {
    return 'system';
  }
}

export function writeChoice(choice: ThemeChoice, storage?: Pick<Storage, 'setItem' | 'removeItem'>): void {
  try {
    if (choice === 'system') storage?.removeItem(THEME_KEY);
    else storage?.setItem(THEME_KEY, choice);
  } catch {
    // A private window can refuse storage. The theme still applies for this visit.
  }
}
